/**
 * Exercise-name enumeration (`Activity.name`, `ExerciseV2Model.name`,
 * `ExerciseV1Model.name`, `SelectedAlternative.name`): index = wire value,
 * 0 = "None". Generated verbatim from the mobile app's `WorkoutExerciseNames`
 * (PrecisionReactNative docs/api-contracts/weekly-workout-response/
 * exercise-names.md, 590 entries) — regenerate rather than edit by hand.
 */
export const EXERCISE_NAMES: readonly string[] = [
  "None",
  "Barbell Standing Bicep Curl",
  "Barbell Landmine Row",
  "Barbell Pronated Pendlay Row",
  "Barbell Bentover Row",
  "Barbell Supinated Pendlay Row",
  "Barbell Supinated Row",
  "Barbell Conventional Deadlift",
  "Inverted Row",
  "Barbell High Bar Good Morning",
  "Barbell Low Bar Good Morning",
  "Barbell Sumo Deadlift",
  "Barbell Staggered Deadlift",
  "Barbell Single Leg Deadlift",
  "Barbell Romanian Deadlift",
  "Barbell Pause Box Squat",
  "Barbell Pause Squat",
  "Barbell Snatch Grip Deadlift",
  "Barbell Snatch Grip Romanian Deadlift",
  "Landmine Romanian Deadlift",
  "Landmine T Bar Rows",
  "Barbell Roll Outs",
  "Barbell Situp",
  "Barbell Toes Up Calf Raise",
  "Landmine Calf Raise",
  "Barbell Back Squat",
  "Barbell Stiff Leg Romanian Deadlift",
  "Barbell Hip Thrust",
  "Barbell Bulgarian Split Squat",
  "Barbell Front Squat",
  "Barbell High Bar Squat",
  "Barbell Front Rack Step Up",
  "Barbell Glute Bridge",
  "Barbell Heels Up Back Squat",
  "Barbell Heels Up Front Squat",
  "Barbell Backward Lunge Alternately",
  "Barbell Split Squat",
  "Barbell Step Up Balance",
  "Barbell Step Up",
  "Barbell Tap Pause Squat",
  "Barbell Feet Elevated Glute Bridge",
  "Barbell Feet Elevated Single Leg Glute Bridge",
  "Landmine Lateral Lunge",
  "Landmine Lunge",
  "Landmine Single Leg Romanian Deadlift",
  "Landmine Staggered Romanian Deadlift",
  "Landmine Sumo Deadlift",
  "Barbell Overhead Press",
  "Barbell Z Press",
  "Barbell Bench Press",
  "Barbell Incline Bench Press",
  "Barbell Laying Triceps Extensions",
  "Barbell Close Grip Bench Press",
  "Barbell Skullcrusher",
  "Barbell Overhead Tricep Extension",
  "Barbell Silverback Shrug",
  "Barbell Shrug",
  "Dumbbell Standing Bicep Curl",
  "Dumbbell Standing Hammer Curl",
  "Dumbbell Bayesian Curl",
  "Dumbbell Incline Hammer Curl",
  "Dumbbell Incline Reverse Curl",
  "Dumbbell Incline Zottman Curl",
  "Dumbbell SA Row",
  "Dumbbell Laying Incline Row",
  "Dumbbell Single Arm Preacher Bicep Curl",
  "Dumbbell Single Arm Row",
  "Dumbbell Single Arm Row Knee",
  "Dumbbell Spider Curl",
  "Dumbbell Twisting Curl",
  "Dumbbell Concentration Curl",
  "Dumbbell Supinated Row",
  "Dumbbell Bentover Row",
  "Dumbbell Rear Delt Row",
  "Dumbbell Wrist Extension",
  "Dumbbell Romanian Deadlift",
  "Dumbbell Front Rack Pause Squat",
  "Dumbbell Single Leg Single Arm Deadlift",
  "Dumbbell Single Leg Stiff Leg Deadlift",
  "Dumbbell Staggered Deadlift",
  "Dumbbell Sumo Squat",
  "Dumbbell Superman",
  "Dumbbell Mat Sit Ups",
  "Dumbbell Russian Twist",
  "Dumbbell Plank Pullthrough",
  "Dumbbell Hollow Hold",
  "Dumbbell Renegade Row",
  "Dumbbell Crunch",
  "Pushup to Renegade Row",
  "Dumbbell Suitcase Crunch",
  "Dumbbell Seated Calf Raise",
  "Dumbbell Seated Tibialis Raise",
  "Dumbbell Wrist Curl",
  "Dumbbell Goblet Squat",
  "Dumbbell Goblet Good Morning",
  "Dumbbell Goblet Bulgarian Split Squat",
  "Dumbbell Hip Thrust",
  "Dumbbell Glute Bridge",
  "Dumbbell Bulgarian Split Squat",
  "Dumbbell Forward Lunge",
  "Dumbbell Goblet Curtsy Lunge",
  "Dumbbell Goblet Forward Lunge",
  "Dumbbell Side Lunge",
  "Dumbbell Goblet Reverse Lunge",
  "Dumbbell Goblet Split Squat",
  "Dumbbell Lateral Lunge Reach",
  "Dumbbell Backward Lunge",
  "Dumbbell Split Squat",
  "Dumbbell Figure Four Glute Bridge",
  "Dumbbell Figure Four Hip Thrust",
  "Dumbbell Front Rack Squat",
  "Dumbbell Heels Up Goblet Squat",
  "Dumbbell Heels Up Narrow Goblet Squat",
  "Dumbbell Offset Squat",
  "Dumbbell Single Leg Glute Bridge",
  "Dumbbell Single Leg Hip Thrust",
  "Dumbbell Staggered Hip thrust",
  "Dumbbell Thruster",
  "Dumbbell Feet Elevated Glute Bridge",
  "Dumbbell Overhead Squat",
  "Dumbbell Leg Curl",
  "Dumbbell Pullover",
  "Dumbbell Standing Side Lateral Raise",
  "Dumbbell Rear Delt Fly",
  "Dumbbell Seated Shoulder Press",
  "Dumbbell Front Raise",
  "Dumbbell Seated Pronated Rear Delts",
  "Dumbbell Chest Supported Side Lateral Raise",
  "Dumbbell Laying Reverse Fly",
  "Dumbbell Laying Reverse Fly Internally Rotated",
  "Dumbbell Seated Shoulder Press Neutral Grip",
  "Dumbbell Seated Arnold Press",
  "Dumbbell Arnold Press",
  "Dumbbell Standing Overhead Shoulder Press",
  "Dumbbell Overhead Press",
  "Dumbbell Push Press",
  "Dumbbell Single Arm Arnold Press",
  "Dumbbell Single Arm Neutral Overhead Press",
  "Dumbbell Upright Row",
  "Dumbbell Incline Fly",
  "Dumbbell Incline Press",
  "Dumbbell Seated Overhead Tricep Extension",
  "Dumbbell Lying Bench Tricep Extension",
  "Dumbbell Flat Bench Press",
  "Dumbbell Decline Bench Press",
  "Dumbbell Decline Neutral Bench Press",
  "Dumbbell Decline Skullcrusher",
  "Dumbbell Guillotine Bench Press",
  "Dumbbell Guillotine Incline Bench Press",
  "Dumbbell Neutral Bench Press",
  "Dumbbell Neutral Incline Bench Press",
  "Dumbbell Rolling Tricep Extension",
  "Dumbbell Squeeze Press",
  "Dumbbell Standing SA Tricep Kickback",
  "Dumbbell Elevated Pushup",
  "Dumbbell Overhead Tricep Extension",
  "Dumbbell Tate Press",
  "Dumbbell Seated Shrugs",
  "Dumbbell Shrug",
  "Dumbbell Leg Extension",
  "Dumbbell Flat Bench Fly",
  "Dumbbell Incline Chest Fly",
  "Dumbbell Overhead Side Bend",
  "Dumbbell Long Lever Russian Twist",
  "Dumbbell Walking Lunge",
  "Dumbbell Squat",
  "Dumbbell Farmers Walk",
  "Dumbbell Step Up",
  "Cable Straight bar Lat Push Down",
  "Cable Bayesian Curl",
  "Cable Hammer Curl",
  "Cable Silverback Shrug",
  "Cable Goblet Squat",
  "Cable Single Leg Deadlift",
  "Cable Pull Through",
  "Cable Glute Kickback",
  "Cable Standing Crunch",
  "Cable Kneeling Crunch",
  "Cable Wrist Curl",
  "Cable Reverse Curl",
  "Cable Split Squat",
  "Cable Hip Abduction",
  "Cable Hamstring Curl",
  "Cable Pullover",
  "Cable Kneeling SA Row",
  "Cable Standing Shoulder Press",
  "Cable Side Lateral Raises",
  "Cable Standing Rear Delts",
  "Cable Upright Row",
  "Cable Standing Chest Press",
  "Cable Cross Pushdown",
  "Cable Overhead Tricep Extension",
  "Cable Standing Shrugs",
  "Cable Standing Chest Fly",
  "Cable Wood Chopper",
  "Cable Pallof Press",
  "Cable Rope Overhead Extension",
  "Cable Face Pulls",
  "Kettlebell Bicep Curl",
  "Kettlebell SA Bench Bicep Curl",
  "Kettlebell SA Bicep Curl",
  "Kettlebell Row",
  "Kettlebell Gorilla Shrugs",
  "Kettlebell Incline Shrug",
  "Kettlebell Russian Swings",
  "Kettlebell Staggered Stance RDLs",
  "Kettlebell Good Morning",
  "Kettlebell Situp",
  "Kettlebell Russian Twists",
  "Kettlebell Standing SL Calf Raises",
  "Kettlebell Standing Calf Raises",
  "Kettlebell Farmers Carry",
  "Kettlebell Glute Bridge",
  "Kettlebell Single Leg Hip Thrust",
  "Kettlebell Single Leg Deadlift",
  "Kettlebell Sumo Goblet Squat",
  "Kettlebell Shoulder Extension",
  "Kettlebell Single Arm Row",
  "Kettlebell Pullover",
  "Kettlebell Front Raise",
  "Kettlebell Single Arm Rear Delt Fly",
  "Kettlebell Long Lever Lateral Raise",
  "Kettlebell Standing Tricep Extension",
  "Kettlebell Shrug",
  "Kettlebell Upright Row",
  "Kettlebell Goblet Squat",
  "Kettlebell Goblet Squat Heels Elevated",
  "Kettlebell Reverse Lunge",
  "Kettlebell Forward Lunge",
  "Kettlebell Lateral Lunge",
  "Kettlebell Chest Press",
  "Kettlebell Single Arm Press",
  "Kettlebell Concentration Curl",
  "Kettlebell Overhead Press",
  "Kettlebell Single Arm Tricep Extension",
  "Kettlebell Push Up",
  "Kettlebell Romanian Deadlift",
  "Kettlebell Clean And Press",
  "Kettlebell Front Squat",
  "Kettlebell Snatch",
  "Kettlebell Chest Fly On The Floor",
  "Kettlebell Halo",
  "Kettlebell Windmill",
  "Kettlebell Step Up",
  "Turkish Get Up",
  "Plate Bicep Curl",
  "Plate Internally Rotated Rear Delt Fly",
  "Plate Rear Delt Fly",
  "Plate Deadlift",
  "Plate Good Morning Anterior",
  "Plate Good Morning",
  "Plate Single Leg Deadlift",
  "Plate Staggered Deadlift",
  "Abdominals Stretch Variation Four",
  "Plate Russian Twist",
  "Plate Sit Ups",
  "Weighted Forearm Plank",
  "Weighted Hand Plank",
  "Plate Hollow Hold",
  "Halo",
  "Calves Stretch Variation Three",
  "Plate Pinch Grip Farmers Carry",
  "Assisted Bulgarian Split Squat",
  "Bodyweight Squat Heels Elevated",
  "Plate GTOH",
  "Plate Clean",
  "Plate Lateral Lunge",
  "Plate Forward Lunge",
  "Band Hip Abduction",
  "Plate Deficit Lunge",
  "Plate Overhead Walking Lunge",
  "Plate Squat Hold",
  "Plate Thruster",
  "Box Jump",
  "Depth Jump",
  "Seated Box Jump",
  "Single Leg Box Jump",
  "Ball Offset Squat",
  "Wall Ball Overhead Backward Lunge",
  "Wall Ball Overhead Squat",
  "Reverse Lunge",
  "Squat Reach",
  "Wall Ball",
  "Feet Elevated Glute Bridge",
  "Half Burpee",
  "Single Leg Elevated Glute Bridge",
  "Squat",
  "Press Jack",
  "Plate Front Raise",
  "Plate Halo",
  "Plate Full Lateral Raise",
  "Plate Lateral Raise",
  "Plate Reach",
  "Bodyweight Chest Dips",
  "Bodyweight Tricep Dips",
  "Bodyweight Tricep Bench Dips",
  "Plate Reverse Lunge Twist",
  "Bodyweight Deficit Push Up",
  "Child Pose Elbows On Block",
  "Pyramid Prayer",
  "Plate Overhead Shrug",
  "Pike Shrug",
  "Bodyweight Bulgarian Split Squat",
  "Bodyweight Reverse Step Up",
  "Plate Squat",
  "Plate Reverse Lunge",
  "Band Leg Extension",
  "Plate Overhead Squat",
  "Incline Push Up",
  "Decline Push Up",
  "Supported Matsyasana Pose",
  "Yogi Arm Clock",
  "Plate Standing Twist",
  "Russian Twist",
  "Machine Assisted Tricep Dips",
  "Machine Belt Squat",
  "Machine Hip Thrust",
  "Machine Leg Extension",
  "Machine Lower Back Extension",
  "Machine Lying Leg Curl",
  "Machine Seated Calf Dorsiflexion",
  "Machine Seated Calf Raises",
  "Machine Seated Close Grip Row",
  "Machine Seated Horizontal Grip Row",
  "Machine Seated Incline Chest Press",
  "Machine Seated Pec Fly",
  "Machine Seated Rear Delts",
  "Machine Seated Reverse Grip Lat Pulldown",
  "Machine Seated SA Reverse Grip Lat Pulldown",
  "Machine Seated SA Seated Row",
  "Machine Standing Abductor",
  "Machine Standing Calf Raises",
  "Machine Supported T Bar Row",
  "Machine Leg Press",
  "Machine Horizontal Leg Press",
  "Reverse Hyperextension",
  "Band Bayesian Curl",
  "Band Bayesian Hammer Curl",
  "Band Kneeling Single Arm Pulldown",
  "Band Bayesian Reverse Curl",
  "Band High Curl",
  "Band High Hammer Curl",
  "Band High Reverse Curl",
  "Band Standing Bicep Curl",
  "Band Reverse Curl",
  "Band Horizontal Shrug",
  "Band Pull Apart",
  "Band Facepulls",
  "Band Rear Delt",
  "Band Good Morning",
  "Band Pullthrough",
  "Band Romanian Deadlift",
  "Band Crunch",
  "Band Spanish Squat",
  "Band Glute Kickback",
  "Band Squat",
  "Band Leg Curl",
  "Band Pullover",
  "Band Row",
  "Band Front Raise",
  "Band Standing Side Lateral Raises",
  "Band Single Arm Overhead Press",
  "Band Single Arm Side Lateral Raise",
  "Band Mid Lateral Raise",
  "Band Overhead Press",
  "Band Overhead Tricep Extension",
  "Band Tricep Extension",
  "Band Pushup",
  "Band Skullcrusher",
  "Band Rapunzel Pushdown",
  "Band Single Arm Pushdown",
  "Single Arm Rapunzel Pushdown",
  "Band Single Arm Skullcrusher",
  "Band Shrug",
  "Band Single Arm Pec Fly",
  "Band Single Arm Chest Press",
  "Band Chest Fly",
  "Band Chest Press",
  "Band Internally Rotated Chest Fly",
  "Band Wood Chopper",
  "Band Pallof Press",
  "Band Reverse Lunge",
  "Band Front Squat",
  "Band Leg Press",
  "Band Lateral Walk",
  "Band Bulgarian Split Squat",
  "Band Glute Bridge",
  "Biceps Stretch Variation Five",
  "Biceps Stretch Variation Four",
  "Biceps Stretch Variation Three",
  "Biceps Stretch Variation Two",
  "Biceps Stretch Variation One",
  "Downward Dog",
  "Downward Dog With Fingers Facing Feet",
  "Elevated Pike Press",
  "Bodyweight Good Mornings",
  "Supermans",
  "Bodyweight Ab Crunches",
  "Laying Leg Raises",
  "Abdominals Stretch Variation Three",
  "Abdominals Stretch Variation Two",
  "Bodyweight Mckenzie Press Up",
  "Bodyweight Russian Twist",
  "Long Lever Plank",
  "Bodyweight Hand Plank",
  "Hollow Hold",
  "Bodyweight Mountain Climbers",
  "Bodyweight Push Up Burpee",
  "Bodyweight Elbow Plank",
  "Calves Stretch Variation Two",
  "Calves Stretch Variation One",
  "Tip Toe Walking",
  "Calf Raises",
  "Walking Calf Raises",
  "Forearms Stretch Variation Four",
  "Forearms Stretch Variation Three",
  "Forearms Stretch Variation Two",
  "Forearms Stretch Variation One",
  "Glutes Stretch Variation Three",
  "Glutes Stretch Variation Two",
  "Glutes Stretch Variation One",
  "Bodyweight Side Lunge",
  "Bodyweight Curtsy Lunge",
  "Bodyweight Forward Lunge",
  "Bodyweight Split Squat",
  "Bodyweight Feet Elevated Figure Four Glute Bridge",
  "Bodyweight Feet Elevated Glute Bridge",
  "Bodyweight Feet Elevated Single Leg Glute Bridge",
  "Kickbacks",
  "Single Legged Romanian Deadlifts",
  "Nordic Hamstring Curl",
  "Bodyweight Reverse Lunge",
  "Lats Stretch Variation Three",
  "Lats Stretch Variation Two",
  "Lats Stretch Variation One",
  "Shoulders Stretch Variation Four",
  "Shoulders Stretch Variation Three",
  "Shoulders Stretch Variation Two",
  "Shoulders Stretch Variation One",
  "Eagle Arm Pose",
  "Reverse Prayer",
  "Triceps Stretch Variation Three",
  "Triceps Stretch Variation Two",
  "Triceps Stretch Variation One",
  "Diamond Push Ups",
  "Traps Stretch Variation Three",
  "Traps Stretch Variation Two",
  "Traps Stretch Variation One",
  "Quads Stretch Variation Four",
  "Quads Stretch Variation Three",
  "Quads Stretch Variation Two",
  "Quads Stretch Variation One",
  "Bodyweight Squat",
  "Chair Pose",
  "Chest Stretch Variation Four",
  "Chest Stretch Variation Three",
  "Chest Stretch Variation Two",
  "Chest Stretch Variation One",
  "Bodyweight Push Up",
  "Side Plank Reach Through",
  "Bodyweight Side Elbow Plank",
  "Hand Side Plank",
  "Bodyweight Walking Lunge",
  "Clamshells",
  "Pronated Towel Pulldown",
  "Towel Isometric Hold",
  "Reverse Snow Angels",
  "Bodyweight Romanian Deadlift",
  "Bodyweight Reverse Fly",
  "Handstand Push Up",
  "Plank To Push Up",
  "Bodyweight Pistol Squat",
  "Bodyweight Hamstring Curl",
  "Walking Plank",
  "Bodyweight Hip Thrust",
  "Swimming Exercise",
  "Bodyweight Chin Ups",
  "Bodyweight Pull Up",
  "Bodyweight Hanging Knee to Chest",
  "Corpse Pose",
  "Scorpion Twist Pose",
  "Seated Arm Stretch",
  "Traps Mid Back Stretch Variation Two",
  "Traps Mid Back Stretch Variation One",
  "Cat Pose",
  "Easy Seated Twist Pose",
  "Revolved Side Angle Pose With Prayer Hands Beginner",
  "Revolved Side Angle Pose With Prayer Hands",
  "Lower back Stretch Variation Four",
  "Lower back Stretch Variation Three",
  "Lower back Stretch Variation Two",
  "Lower back Stretch Variation One",
  "Happy Baby",
  "Sphinx Pose",
  "Cobra Pose",
  "Downward Dog Toe To Heel",
  "Table Top Pose Variation 1",
  "Table Top Pose Variation 2",
  "Table Top Pose Variation 3",
  "Vajrasana Variation 1",
  "Double Pigeon Pose",
  "Half Lotus",
  "Pigeon Pose",
  "Reclining Pigeon Pose",
  "Restful Cow Face Pose Legs",
  "Hamstrings Stretch Variation Four",
  "Hamstrings Stretch Variation Three",
  "Hamstrings Stretch Variation Two",
  "Hamstrings Stretch Variation One",
  "Half Monkey Pose",
  "Seated Forward Bend",
  "Pyramid Pose",
  "Standing Forward Bend Blocks",
  "Standing Forward Bend",
  "Wide Legged Standing Forward Bend Holding Heels",
  "Child Pose Arms Extended",
  "Extended Side Angle Pose",
  "Wide Legged Forward Fall",
  "One Arm Cow Face Pose",
  "Easy Pose Neck Stretch",
  "Half Neck Rolls",
  "Crescent Moon Pose",
  "Crescent Moon Pose Quad Stretch",
  "Runners Lunge",
  "Bow Pose",
  "Gate Pose Variation Arm Extended on Side",
  "Revolved Head To Knee",
  "Seated Side Bend Pose",
  "Supine Twist Lying",
  "Suspension Trainer Bicep Curl",
  "Suspension Trainer Reverse Curl",
  "Suspension Trainer Rear Delts",
  "Suspension Trainer Horizontal Row",
  "Suspension Trainer W Raise",
  "Suspension Trainer Ab Rollout",
  "Suspension Trainer Forearm Plank",
  "Suspension Trainer Hand Plank",
  "Suspension Trainer Kneeling Ab Rollout",
  "Suspension Trainer Knee Tuck",
  "Suspension Trainer Mountain Climbers",
  "Suspension Trainer Pike Abs",
  "Suspension Trainer Glute Bridge",
  "Suspension Trainer Lateral Lunge",
  "Suspension Trainer Backward Lunge",
  "Suspension Trainer Backward Lunge Alternately",
  "Suspension Trainer Split Squat",
  "Suspension Trainer Squat",
  "Suspension Trainer Hamstring Curl",
  "Suspension Trainer Single Arm Row",
  "Suspension Trainer Pushup",
  "Suspension Trainer Y Raise",
  "Suspension Trainer Overhead Tricep Extension",
  "Suspension Trainer Pec Fly",
  "Suspension Trainer Forearm Side Plank",
  "Suspension Trainer Oblique Crunch",
  "Suspension Trainer Rear Delt",
  "Suspension Trainer Pistol Squat",
  "Suspension Trainer Stationary Lunge",
  "Suspension Trainer Atomic Push Up",
  "Suspension Trainer Body Saw",
  "Suspension Trainer Hip Hinge",
  "Suspension Trainer Calf Raise",
  "Suspension Trainer Single Leg Deadlift",
  "Bike Exercise",
  "Treadmill Running",
  "Rowing Exercise",
  "Elliptical Exercise",
  "Jumping Rope Exercise",
  "Boxing Exercise",
  "Dumbbell Reverse Curl",
  "Dumbbell Incline Curls",
  "Dumbbel Laying Incline Row",
  "Hack Squat",
  "Kneeling Single Arm High Pulley Row",
  "Lat Focused Cable Row Gironda",
  "Low To High Cable Chest Fly Clavicular",
  "Dumbbell Lateral Raises",
  "Smith Machine Back Squat",
  "Smith Machine Bench Press",
  "Smith Machine Incline Press",
  "Smith Machine Lying Tricep Extensions",
  "Smith Machine Reverse Lunge",
  "Smith Machine Romanian Deadlifts",
  "Smith Machine Shoulder Press",
  "Smith Machine Split Squat",
  "Straight Bar Overhead Tricep Extensions",
  "Wide Grip Lat Pulldown",
  "Medicine Ball Overhead Squat",
  "Medicine Ball Backward Lunge",
  "Bosu Ball Squat",
];

/**
 * Label for an exercise-name id. Unknown ids (the backend table can grow ahead
 * of this snapshot) fall back to the exercise's own `title`, then "Exercise".
 */
export const exerciseName = (id: number, title?: string): string =>
  EXERCISE_NAMES[id] || (title ?? "").trim() || "Exercise";
